import React, { useState } from 'react';
import { Table, Input, Button, Space, Typography, Select } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Title } = Typography;
const { Option } = Select;

const ItemTable = ({
  items,
  onEdit,
  onDelete,
  onAdd,
  loading,
  departmentName,
  categories = [],
  onCategoryChange,
  onSearch,
  pagination,
  onTableChange
}) => {
  const [nameFilter, setNameFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      filteredValue: nameFilter ? [nameFilter] : null,
      onFilter: (value, record) =>
        record.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Category',
      dataIndex: 'categoryName',
      key: 'categoryName',
      filteredValue: categoryFilter ? [categoryFilter] : null,
      onFilter: (value, record) => record.categoryId === value,
    },
    {
      title: 'Quantity In Stock',
      dataIndex: 'quantityInStock',
      key: 'quantityInStock',
    },
    {
      title: 'Reorder Level',
      dataIndex: 'reorderLevel',
      key: 'reorderLevel',
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
    },
    {
      title: 'Cost Price',
      dataIndex: 'costPrice',
      key: 'costPrice',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          />
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(record)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: '16px', display: 'flex', gap: '16px' }}>
        <Search
          placeholder="Search by name"
          allowClear
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onSearch={(value) => {
            if (onSearch) {
              onSearch(value);
            } else {
              setNameFilter(value);
            }
          }}
          style={{ width: 200 }}
        />
        {/*<Select*/}
        {/*  placeholder="Filter by Category"*/}
        {/*  allowClear*/}
        {/*  style={{ width: 200 }}*/}
        {/*  onChange={(value) => {*/}
        {/*    setCategoryFilter(value);*/}
        {/*    if (onCategoryChange) {*/}
        {/*      onCategoryChange(value);*/}
        {/*    }*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {categories.map(category => (*/}
        {/*    <Option key={category.id} value={category.id}>{category.name}</Option>*/}
        {/*  ))}*/}
        {/*</Select>*/}
      </div>

      <Table
        columns={columns}
        dataSource={items}
        rowKey="id"
        loading={loading}
        onChange={onTableChange}
        pagination={pagination || {
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          pageSize: 10,
          pageSizeOptions: ['5', '10', '25'],
        }}
      />
    </div>
  );
};

export default ItemTable;
